import * as React from 'react';
import * as trace from 'owa-trace';
import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import LoadMoreError from 'mini-error-handler/lib/components/LoadMoreError';
import loadMoreInTable from 'mini-mail-list-actions/lib/actions/tables/loadMoreInTable';
import MailItemWrapper from './MailItemWrapper';
import MailListHeader from '../MailListHeader';
import MailListLoading from '../MailListLoading';
import { FocusedOtherCampaign } from 'mini-mail-campaign-view/lib/components/FocusedOtherCampaign';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { ItemRendererProp } from 'mini-virtualized-list/lib/components/VirtualizedList';
import { LazyAutomaticRepliesBanner } from 'mini-mail-automatic-replies-banner-view';
import { LazyFocusedInboxRollup } from 'mini-mail-focused-inbox-rollup-view';
import { LazyGreenRoomBanner } from 'mini-mail-greenroom';
import { NativeAdContainer } from 'mini-mail-nativead-view';
import { RowComponentsID } from '../../utils/mailList/getListItemHeight';

const styles = require('./VirtualizedMailListItem.scss');

const VirtualizedMailListItem = (props: ItemRendererProp<string>) => {
    const { data, index, style, forwardedRefs, forwardedRef } = props;
    const virtualListItemId = data[index];

    if (!virtualListItemId) {
        trace.errorThatWillCauseAlert('VirtualizedMailListItem: VirtualListItemId not found');
        return null;
    }

    let listItemElem: JSX.Element = null;
    let className: string = '';

    switch (virtualListItemId) {
        case RowComponentsID.GreenRoom:
            listItemElem = <LazyGreenRoomBanner forwardedRef={forwardedRef} />;
            break;
        case RowComponentsID.ListHeader:
            listItemElem = <MailListHeader forwardedRefs={forwardedRefs} />;
            className = styles.mailListHeader;
            break;
        case RowComponentsID.AutomaticReplyBanner:
            listItemElem = <LazyAutomaticRepliesBanner />;
            break;
        case RowComponentsID.FocusedInboxRollup:
            listItemElem = <LazyFocusedInboxRollup />;
            break;
        case RowComponentsID.AdBannerContainer:
            listItemElem = <NativeAdContainer />;
            className = styles.adBannerContainer;
            break;
        case RowComponentsID.AdContainerExp:
            listItemElem = <NativeAdContainer />;
            break;
        case RowComponentsID.Spinner:
            listItemElem = <MailListLoading className={styles.mailListLoading} />;
            break;
        case RowComponentsID.LoadError:
            listItemElem = (
                <LoadMoreError
                    title={getOwaMiniCommonStrings().mailListLoadMoreErrorTitle}
                    onRetry={() => loadMoreInTable(getCurrentSelectedTableView())}
                    spacerOptions={{ bottomSpacer: true }}
                />
            );
            break;
        case RowComponentsID.FocusedOtherCampaign:
            listItemElem = <FocusedOtherCampaign />;
            break;
        default:
            return (
                <MailItemWrapper
                    itemId={virtualListItemId}
                    isScrolling={props.isScrolling}
                    style={style}
                />
            );
    }

    return (
        <div style={style} className={className}>
            {listItemElem}
        </div>
    );
};

export default VirtualizedMailListItem;
